import avatarURL from "../../../../../../../../utils/avatarURL";

// The purpose of this function is to extract avatar urls from a review report query
// This will be improved in the future once the integrate code gen for typescript
const rawReviewReportAvatarsExtractor = (rawData, type, nameKeyOne, nameKeyTwo) => {
	if (type === null || !rawData) {
		return null;
	}

	if (type !== "employee") {
		return [];
	}

	return rawData?.reviewReportsVisualization
		?.map((row) => {
			const avatarUrl =
				type === "employee" && row.summarizeBy[nameKeyOne][nameKeyTwo]?._id
					? avatarURL(row.summarizeBy[nameKeyOne][nameKeyTwo]._id)
					: null;
			return avatarUrl;
		})
		.filter((avatarUrl) => avatarUrl);
};

export { rawReviewReportAvatarsExtractor };
